import type { Translations } from "../keys.js";

export const ko = {
  eyebrow: "IBKR 활동 명세서",
  title: "손익비 리포트",
  uploadMark: "Flex XML",
  uploadTitle: "IBKR XML 드롭 또는 선택",
  uploadBody: "이름, 계좌, 주소는 화면에서 마스킹됩니다.",
  nfaDisclaimer: "학습과 거래 리뷰용이며 투자 조언이 아닙니다.",
  chooseFile: "파일 선택",
  account: "계좌",
  name: "이름",
  neutralName: "모모",
  period: "기간",
  baseCurrency: "기준 통화",
  closed: "청산",
  executions: "체결",
  netRealized: "실현 손익",
  winRate: "승률",
  payoffRatio: "손익비",
  expectancy: "기대값",
  executionRecords: "체결 기록",
  canceledOrders: "취소 주문",
  medianHoldingDays: "보유일 중앙값",
  commissionDrag: "수수료",
  closedTradeSum: "청산 합계",
  grossProfitLoss: "총이익 / 총손실",
  averageWinLoss: "평균 이익 / 평균 손실",
  perClosedTrade: "청산 1건 평균",
  flexTradeRecords: "Flex XML Trade 기록",
  flexCanceledRecords: "Flex XML의 취소 Order 기록",
  noCanceledRecords: "취소 주문 없음",
  holdingReview: "Holding",
  holdingReviewTitle: "보유 기간과 손익비 분석",
  holdingReviewHint: "진입과 청산을 매칭해 보유 기간별 PF, 손익비, 승률을 비교합니다.",
  holdingPeriod: "보유 기간",
  holdingIntraday: "당일",
  holdingSwing: "1-7일",
  holdingPosition: "8-30일",
  holdingLongTerm: "30일 이상",
  directionReview: "Direction",
  directionReviewTitle: "롱 / 숏 포지션 분석",
  directionReviewHint: "전략 노출 기준으로 청산 거래를 나누어 어느 쪽에 우위가 있는지 확인합니다.",
  longPosition: "롱",
  shortPosition: "숏",
  neutralPosition: "중립",
  equityCurve: "자산 곡선",
  dailyRealized: "일별 실현 손익",
  payoff: "손익비",
  winLossDistribution: "승패 분포",
  periodPerformance: "기간별 성과",
  periodHint: "녹색 막대는 이익, 빨간 막대는 손실입니다. PF와 손익비는 아래 표에서 확인하세요.",
  weekly: "주간",
  monthly: "월간",
  periodColumn: "기간",
  monthColumn: "월",
  realized: "실현",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "손익비",
  trades: "건수",
  assetBreakdown: "자산별",
  assetBreakdownTitle: "주식 / 옵션 통계",
  asset: "자산",
  medianPnl: "손익 중앙값",
  average: "평균",
  optionReview: "옵션",
  optionReviewTitle: "기초자산별 옵션 리뷰",
  underlying: "기초자산",
  date: "날짜",
  dateCount: "날짜 수",
  daysShort: "일",
  hoursShort: "시간",
  minutesShort: "분",
  weakestSession: "가장 약한 세션",
  intradaySessionNoData: "정규장 청산 없음",
  intradaySessionTitle: "장초반 / 점심 / 장마감 승률 분석",
  intradaySessionHint: "청산 시간을 기준으로 세션별 실현손익, 중앙값, 평균, PF, 손익비, 승률을 비교합니다.",
  weekdayReviewTitle: "요일별 거래 성과",
  weekdayReviewHint: "정규장 청산과 자동 만기를 요일별로 비교해 손익비가 가장 좋은 날과 가장 나쁜 날을 보여줍니다.",
  weekday: "요일",
  weekdaySunday: "일요일",
  weekdayMonday: "월요일",
  weekdayTuesday: "화요일",
  weekdayWednesday: "수요일",
  weekdayThursday: "목요일",
  weekdayFriday: "금요일",
  weekdaySaturday: "토요일",
  bestDay: "최고",
  worstDay: "최악",
  session: "세션",
  sessionMorning: "장초반",
  sessionMidday: "점심",
  sessionLate: "장마감",
  autoExpiry: "자동 만기",
  optionLifecycle: "만기 / 결제",
  optionLifecycleRegularClose: "일반 청산",
  optionLifecycleEp: "만기 소멸",
  optionLifecycleEx: "권리 행사",
  optionLifecycleA: "배정",
  optionLifecycleCD: "현금 결제",
  optionLifecycleAEx: "자동 행사",
  optionLifecycleMEx: "수동 행사",
  optionLifecycleGEA: "상계 만기 / 배정",
  discipline: "규율",
  disciplineRisk: "규율 리스크",
  largeLossAlert: "대형 손실 경고",
  largeLossDiscipline: "먼저 멈추고 규율을 지키세요",
  largeLossRule: "이 날의 총손실은 현재 리스크 기준을 넘었습니다. 만회하려고 규모를 키우기 전에 계획한 손절, 일일 최대 손실, 멈춤 규칙을 먼저 확인하세요.",
  worstLossDay: "최대 일일 손실",
  symbols: "종목",
  symbolPerformance: "종목 순위",
  page: "페이지",
  previousPage: "이전 페이지",
  nextPage: "다음 페이지",
  offlineCoach: "오프라인 코치",
  offlineAdvice: "오프라인 조언",
  bestLoserWins: "좋은 패자가 이긴다",
  theme: "테마",
  language: "언어",
  dark: "다크",
  light: "라이트",
  stock: "주식",
  option: "옵션",
  other: "기타",
  cash: "현금",
  future: "선물",
  unknown: "알 수 없음",
  lossBucketSmall: "소액 손실",
  lossBucketMedium: "중간 손실",
  lossBucketLarge: "큰 손실",
  winBucketSmall: "소액 이익",
  winBucketMedium: "중간 이익",
  winBucketLarge: "큰 이익",
  chartEmpty: "표시할 청산 거래가 없습니다",
  dailyChartLegend: "막대: 일별, 선: 누적",
  periodChartLegend: "PF 점, 기준 1.00, 상한",
  importFailed: "가져오기 실패",
  profitStatus: "이익",
  lossStatus: "손실",
  flatStatus: "보합",
  costStatus: "비용",
  toggleDetails: "상세 보기",
  "error.invalid_flex_xml": "IBKR Flex XML 파일을 업로드하세요.",
  "advice.profit_factor_below_one.title": "PF가 1보다 낮습니다",
  "advice.profit_factor_below_one.body": "현재 PF는 {profitFactor}입니다. 총이익이 아직 총손실을 덮지 못합니다. 거래 수를 늘리기보다 큰 손실, 만기 손실, 통제되지 않은 추가 진입을 먼저 줄이세요.",
  "advice.profit_factor_thin_edge.title": "PF의 여유가 얇습니다",
  "advice.profit_factor_thin_edge.body": "현재 PF는 {profitFactor}입니다. 거래할 수는 있지만 통제되지 않은 손실 한두 번이 전체 기간 성과를 지울 수 있습니다. 일일 최대 손실, 최종 청산 시간, 멈춤 규칙을 먼저 정하세요.",
  "advice.profit_factor_healthy.title": "PF 구조가 비교적 건강합니다",
  "advice.profit_factor_healthy.body": "현재 PF는 {profitFactor}입니다. 빈도를 무작정 늘리지 말고 반복 가능한 종목, 시간대, 셋업을 찾아 품질 높은 거래만 남기세요.",
  "advice.winrate_and_payoff_weak.title": "승률과 손익비가 동시에 약하면 안 됩니다",
  "advice.winrate_and_payoff_weak.body": "승률은 {winRate}, 손익비는 {payoffRatio}입니다. 적중률도 평균 보상도 충분히 보상하지 못하고 있습니다. 진입 전 목표 공간과 손절 거리를 더 엄격히 확인하세요.",
  "advice.high_winrate_weak_payoff.title": "승률이 약한 손익비를 메우고 있습니다",
  "advice.high_winrate_weak_payoff.body": "승률은 {winRate}이지만 손익비는 {payoffRatio}입니다. 나쁜 거래 한 번이 좋은 거래 여러 번을 지울 수 있습니다. 보통 방향성보다 청산과 리스크 정의의 문제입니다.",
  "advice.overtrade_loss_days.title": "손실일에 가속 징후가 있습니다",
  "advice.overtrade_loss_days.body": "{days}일 동안 높은 거래 수와 음수 손익이 동시에 나타났습니다. 첫 손실 이후 거래가 계획의 일부였는지, 손실을 만회하려는 시도였는지 따로 복기하세요.",
  "advice.auto_expiry_losses.title": "자동 만기 손실은 노이즈가 아닙니다",
  "advice.auto_expiry_losses.body": "{count}건의 자동 만기 손실이 포함되었습니다. 만기 영점화는 관리 가능한 리스크로 다루어야 하며, 장 마감 전 사고가 아닙니다. 허용 가능한 최종 청산 시간을 적어두세요.",
  "advice.good_loser_base.title": "좋은 패자는 다음 거래를 지킵니다",
  "advice.good_loser_base.body": "평균 이익은 {avgWin}, 평균 손실은 {avgLoss}입니다. 계획 안의 손실은 비용이고, 계획 밖의 손실은 리스크 정의를 좁혀야 한다는 신호입니다.",
  "advice.detach_outcome_from_ego.title": "손익을 자존심에서 분리하세요",
  "advice.detach_outcome_from_ego.body": "복기할 때 먼저 물어보세요. 이 손실은 계획대로 발생했는가? 그렇다면 비용이고, 아니라면 규율 문제입니다.",
  "advice.large_tail_losses.title": "가장 큰 손실부터 줄이세요",
  "advice.large_tail_losses.body": "{count}건의 손실이 {threshold}를 넘었습니다. PF를 빠르게 개선하는 길은 보통 승률을 올리는 것보다 한 주 성과를 무너뜨리는 꼬리 손실을 자르는 것입니다.",
  "advice.asset_group_relative_edge.title": "{stronger}에 상대적 우위가 있습니다",
  "advice.asset_group_relative_edge.body": "옵션 PF는 {optionProfitFactor}, 주식 PF는 {stockProfitFactor}입니다. PF가 더 안정적인 쪽에 자금과 집중을 두고, 약한 쪽이 단순 테스트나 감정 거래였는지 확인하세요.",
  "advice.option_sample_dominant.title": "현재 표본은 주로 옵션입니다",
  "advice.option_sample_dominant.body": "옵션 PF는 {optionProfitFactor}, 승률은 {optionWinRate}입니다. 총손익만 보지 말고 만기, 행사/배정, 마지막 거래 시간대, IV 변화를 따로 복기하세요.",
  "advice.stock_sample_dominant.title": "현재 표본은 주로 주식입니다",
  "advice.stock_sample_dominant.body": "주식 PF는 {stockProfitFactor}, 승률은 {stockWinRate}입니다. 옵션 결과와 섞기 전에 보유 시간, 손절 일관성, 추격 진입 여부를 확인하세요.",
  "advice.weak_option_underlying_days.title": "약한 옵션 종목-일자를 따로 복기하세요",
  "advice.weak_option_underlying_days.body": "{rows}. 이 조합들은 요약표보다 실제 의사결정 상황에 더 가깝습니다. 방향, 진입 시간, 만기 근접 여부를 먼저 확인하세요.",
  "advice.clean_sample.title": "표본을 깨끗하게 유지하세요",
  "advice.clean_sample.body": "특정 자산군이 명확히 결과를 끌어내리지는 않습니다. 깨끗한 청산 표본을 더 쌓은 뒤 주기성, 종목 집중도, 셋업 안정성을 확인하세요.",
} satisfies Translations;
